export interface AuraChartSeries {
    name: string;
    data: number[];
}

export type AuraChartTableRow = Record<string, unknown>;

export interface AuraChart {
    type: 'line' | 'area' | 'bar' | 'pie' | 'radar' | 'heatmap' | 'table';
    title?: string;
    unit?: string;
    data: unknown[];
    labels?: string[];
    series?: AuraChartSeries[];
    yLabels?: string[];
    points?: Array<[number, number, number]>;
    id?: string;
    stacked?: boolean;
    showShare?: boolean;
    columns?: string[];
    rows?: AuraChartTableRow[];
}
